function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }

    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});

/**
 * Detail Sections Components Manager
 * 统一管理产品详情页的各个组件
 */
window.DetailComponents = {
  
  // Detail Product Features 组件
  ProductFeatures: {
    init: function() {
      const featureHeaders = document.querySelectorAll('.custom-detail-product-features [data-feature-toggle]');
      
      featureHeaders.forEach(header => {
        header.addEventListener('click', function() {
          const featureItem = this.closest('.feature-item');
          const isActive = featureItem.classList.contains('active');
          
          // 关闭所有其他展开的项
          document.querySelectorAll('.custom-detail-product-features .feature-item.active').forEach(item => {
            if (item !== featureItem) {
              item.classList.remove('active');
            }
          });
          
          // 切换当前项的状态
          featureItem.classList.toggle('active');
        });
      });
    }
  },

  // Detail Tech Specs 组件
  TechSpecs: {
    init: function() {
      // 主模块的折叠功能
      const techHeaders = document.querySelectorAll('.custom-detail-tech [data-tech-toggle]');
      
      techHeaders.forEach(header => {
        header.addEventListener('click', function() {
          const techItem = this.closest('.tech-item');
          const isActive = techItem.classList.contains('active');
          
          // 关闭所有其他展开的项
          document.querySelectorAll('.custom-detail-tech .tech-item.active').forEach(item => {
            if (item !== techItem) {
              item.classList.remove('active');
            }
          });
          
          // 切换当前项的状态
          techItem.classList.toggle('active');
        });
      });

      // 表格展开/收起功能
      const techTableExpandButton = document.querySelector('.custom-detail-tech .tech-expand-btn');
      
      if (techTableExpandButton) {
        techTableExpandButton.addEventListener('click', function() {
          const techTableIsExpanded = this.getAttribute('data-expanded') === 'true';
          const techTableHiddenRows = document.querySelectorAll('.custom-detail-tech .tech-data-row[data-row]');
          const techTableIcon = this.querySelector('.expand-icon');
          
          if (techTableIsExpanded) {
            // 收起：只显示前5行
            techTableHiddenRows.forEach(function(techTableRow) {
              const techTableRowNumber = parseInt(techTableRow.getAttribute('data-row'));
              if (techTableRowNumber > 5) {
                techTableRow.style.display = 'none';
              }
            });
            
            techTableIcon.textContent = '+';
            this.setAttribute('data-expanded', 'false');
          } else {
            // 展开：显示所有行
            techTableHiddenRows.forEach(function(techTableRow) {
              techTableRow.style.display = 'table-row';
            });
            
            techTableIcon.textContent = '−';
            this.setAttribute('data-expanded', 'true');
          }
        });
      }
    }
  },

  // Detail Video 组件
  Video: {
    init: function() {
      const videoHeader = document.querySelector('.custom-detail-video [data-video-toggle]');
      const videoItem = document.querySelector('.custom-detail-video .video-item');
      const playButton = document.querySelector('.custom-detail-video .video-play-button');
      const videoPlayer = document.querySelector('.custom-detail-video .video-player');
      
      if (videoHeader) {
        videoHeader.addEventListener('click', function() {
          const isActive = videoItem.classList.contains('active');
          
          // 关闭所有其他展开的项
          document.querySelectorAll('.custom-detail-video .video-item.active').forEach(item => {
            if (item !== videoItem) {
              item.classList.remove('active');
            }
          });
          
          // 切换当前项的状态
          videoItem.classList.toggle('active');
        });
      }

      if (playButton && videoPlayer) {
        playButton.addEventListener('click', function() {
          const provider = videoPlayer.dataset.provider;
          const coverImage = document.querySelector('.custom-detail-video .video-cover-image');
          const videoContent = document.querySelector('.custom-detail-video .video-content');
          const videoOverlay = document.querySelector('.custom-detail-video .video-overlay');
          
          if (coverImage) coverImage.style.display = 'none';
          if (videoContent) videoContent.style.display = 'none';
          if (videoOverlay) videoOverlay.style.display = 'none';
          videoPlayer.classList.add('is-playing');

          if (provider === 'hosted') {
            const video = videoPlayer.querySelector('video');
            if (video) video.play();
          } else if (provider === 'youtube') {
            const iframe = videoPlayer.querySelector('iframe');
            if (iframe) {
              iframe.src = iframe.src + '?autoplay=1&mute=0';
            }
          } else if (provider === 'vimeo') {
            const iframe = videoPlayer.querySelector('iframe');
            if (iframe) {
              iframe.src = iframe.src + '?autoplay=1&mute=0';
            }
          }
        });
      }
    }
  },

  // Detail Docs 组件
  Docs: {
    init: function() {
      const docsHeaders = document.querySelectorAll('.custom-detail-docs [data-docs-toggle]');
      
      docsHeaders.forEach(header => {
        header.addEventListener('click', function() {
          const docsItem = this.closest('.docs-item');
          const isActive = docsItem.classList.contains('active');
          
          // 关闭所有其他展开的项
          document.querySelectorAll('.custom-detail-docs .docs-item.active').forEach(item => {
            if (item !== docsItem) {
              item.classList.remove('active');
            }
          });
          
          // 切换当前项的状态
          docsItem.classList.toggle('active');
        });
      });
    }
  },

  // Detail FAQ 组件
  FAQ: {
    init: function() {
      // 主模块的折叠功能
      const faqHeaders = document.querySelectorAll('.custom-detail-faq [data-faq-toggle]');
      
      faqHeaders.forEach(header => {
        header.addEventListener('click', function() {
          const faqItem = this.closest('.faq-item');
          const isActive = faqItem.classList.contains('active');
          
          // 关闭所有其他展开的项
          document.querySelectorAll('.custom-detail-faq .faq-item.active').forEach(item => {
            if (item !== faqItem) {
              item.classList.remove('active');
            }
          });
          
          // 切换当前项的状态
          faqItem.classList.toggle('active');
        });
      });

      // FAQ问答项的折叠功能
      const questionHeaders = document.querySelectorAll('.custom-detail-faq [data-faq-question-toggle]');
      
      questionHeaders.forEach(header => {
        header.addEventListener('click', function() {
          const questionItem = this.closest('.faq-question-item');
          questionItem.classList.toggle('active');
        });
      });
    }
  },

  // Detail Navigation 组件
  Navigation: {
    nav: null,
    header: null,
    navContainer: null,
    headerHeight: 0,
    navTop: 0,
    
    init: function() {
      this.nav = document.getElementById('detailNav');
      if (!this.nav) return;
      
      this.header = document.getElementById('header');
      this.navContainer = this.nav.querySelector('.row');
      this.updateHeaderHeight();
      this.navTop = this.nav.offsetTop;
      
      this.bindEvents();
      this.handleScroll();
    },

    // 更新header高度（以防header高度动态变化）
    updateHeaderHeight: function() {
      this.headerHeight = this.header ? this.header.offsetHeight : 0;
    },

    // 绑定事件
    bindEvents: function() {
      // 处理平滑滚动
      document.querySelectorAll('.nav-item').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetValue = link.getAttribute('data-nav-target');
          let targetElement;
          
          // 检查是否是review类型的导航（通过检查是否包含review关键词）
          const navTitle = link.textContent.toLowerCase();
          if (navTitle.includes('review')) {
            // 使用动态的review_class，支持class或id
            targetElement = document.querySelector('.' + targetValue) || document.querySelector('#' + targetValue);
          } else {
            // 使用section_id
            targetElement = document.querySelector(`[data-section-id="${targetValue}"]`);
          }
          
          if (targetElement) {
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const navHeight = this.nav.offsetHeight;
            const offsetPosition = targetPosition - this.headerHeight - navHeight - 40; // 40px额外偏移，确保内容不会被遮挡

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });

      // 监听滚动事件
      window.addEventListener('scroll', () => this.handleScroll());
      
      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        this.updateHeaderHeight();
        this.navTop = this.nav.offsetTop;
        this.handleScroll();
      });
    },

    // 处理滚动事件
    handleScroll: function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > this.navTop - this.headerHeight) {
        this.nav.classList.add('fixed');
        this.nav.style.top = this.headerHeight + 'px';
      } else {
        this.nav.classList.remove('fixed');
      }

      // 更新激活状态
      this.updateActiveNavItem();
    },

    // 更新激活的导航项
    updateActiveNavItem: function() {
      const sections = document.querySelectorAll('[data-section-id]');
      const navItems = document.querySelectorAll('.nav-item');
      
      let currentSection = null;
      let minDistance = Infinity;

      // 检查所有导航项对应的目标元素
      navItems.forEach(navItem => {
        const targetValue = navItem.getAttribute('data-nav-target');
        const navTitle = navItem.textContent.toLowerCase();
        let targetElement;
        
        if (navTitle.includes('review')) {
          // 使用动态的review_class，支持class或id
          targetElement = document.querySelector('.' + targetValue) || document.querySelector('#' + targetValue);
        } else {
          // 使用section_id
          targetElement = document.querySelector(`[data-section-id="${targetValue}"]`);
        }
        
        if (targetElement) {
          const rect = targetElement.getBoundingClientRect();
        const distance = Math.abs(rect.top - this.headerHeight - this.nav.offsetHeight - 40);
        
        if (distance < minDistance) {
          minDistance = distance;
            currentSection = targetElement;
          }
        }
      });

      if (currentSection) {
        // 找到对应的导航项
        navItems.forEach(item => {
          const itemTargetValue = item.getAttribute('data-nav-target');
          const itemNavTitle = item.textContent.toLowerCase();
          let itemTargetElement;
          
          if (itemNavTitle.includes('review')) {
            itemTargetElement = document.querySelector('.' + itemTargetValue) || document.querySelector('#' + itemTargetValue);
          } else {
            itemTargetElement = document.querySelector(`[data-section-id="${itemTargetValue}"]`);
          }
          
          if (itemTargetElement === currentSection) {
            item.classList.add('active');
            // 滚动导航容器到当前激活项
            this.scrollToActiveItem(item);
          } else {
            item.classList.remove('active');
          }
        });
      }
    },

    // 滚动导航容器到激活项
    scrollToActiveItem: function(activeItem) {
      if (!this.navContainer) return;
      
      const containerRect = this.navContainer.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      
      // 计算需要滚动的距离
      let scrollLeft = this.navContainer.scrollLeft;
      
      // 如果激活项在容器左侧
      if (itemRect.left < containerRect.left) {
        scrollLeft -= (containerRect.left - itemRect.left);
      }
      // 如果激活项在容器右侧
      else if (itemRect.right > containerRect.right) {
        scrollLeft += (itemRect.right - containerRect.right);
      }
      
      // 平滑滚动到目标位置
      this.navContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  },

  // Review Summary 组件 - 为插件添加ASK A QUESTION按钮
  ReviewSummary: {
    config: null,
    
    init: function() {
      // 读取配置
      this.loadConfig();
      
      // 如果没有配置，则不执行
      if (!this.config) {
        return;
      }
      
      // 使用MutationObserver监听DOM变化，因为插件内容是动态加载的
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // 使用配置中的ID选择器
                const container = node.querySelector('#' + this.config.reviews_container_id) || 
                                 (node.id === this.config.reviews_container_id ? node : null);
                
                if (container) {
                  this.addAskQuestionButton(container);
                }
                
                // 也检查node本身是否匹配
                if (node.id === this.config.reviews_container_id) {
                  this.addAskQuestionButton(node);
                }
              }
            });
          }
        });
      });

      // 开始观察
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // 也检查页面加载时是否已经存在
      const existingContainer = document.getElementById(this.config.reviews_container_id);
      if (existingContainer) {
        this.addAskQuestionButton(existingContainer);
      }

      // 延迟检查，以防插件加载较慢
      setTimeout(() => {
        const delayedContainer = document.getElementById(this.config.reviews_container_id);
        if (delayedContainer) {
          this.addAskQuestionButton(delayedContainer);
        }
      }, 2000);

      // 再次延迟检查
      setTimeout(() => {
        const finalContainer = document.getElementById(this.config.reviews_container_id);
        if (finalContainer) {
          this.addAskQuestionButton(finalContainer);
        }
      }, 5000);
    },

    loadConfig: function() {
      // 查找配置脚本标签
      const configScript = document.querySelector('script[id^="AskQuestionConfig-"]');
      if (configScript) {
        try {
          const config = JSON.parse(configScript.textContent);
          if (config.enable_ask_question_button) {
            this.config = config;
          }
        } catch (e) {
          console.error('Failed to parse Ask Question config:', e);
        }
      }
    },

    addAskQuestionButton: function(container) {
      // 检查是否已经添加过按钮，避免重复添加
      if (container.querySelector('.ask-question-btn')) {
        return;
      }

      // 创建按钮
      const askQuestionButton = document.createElement('a');
      askQuestionButton.href = this.config.ask_question_button_link || '/pages/contact-us';
      askQuestionButton.textContent = this.config.ask_question_button_text;
      askQuestionButton.className = 'ask-question-btn';
      askQuestionButton.style.cssText = `
        color: #00583F;
        text-decoration: underline;
        font-weight: 500;
        font-size: 14px;
        cursor: pointer;
        position: relative;
      `;

      // 将按钮添加到容器中
      container.appendChild(askQuestionButton);
    }
  },

  // 统一初始化所有组件
  initAll: function() {
    this.ProductFeatures.init();
    this.TechSpecs.init();
    this.Video.init();
    this.Docs.init();
    this.FAQ.init();
    this.Navigation.init();
    this.ReviewSummary.init();
  }
};

// 页面加载完成后初始化所有组件
document.addEventListener('DOMContentLoaded', function() {
  window.DetailComponents.initAll();
});

// 支持动态加载的内容（如 AJAX 加载的产品页面）
document.addEventListener('shopify:section:load', function() {
  window.DetailComponents.initAll();
});


/**
 * Manuals Search functionality
 */
class ManualsSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const tabs = this.querySelectorAll('[data-tab]');
    const tabContents = this.querySelectorAll('[data-tab-content]');
    const searchInput = this.querySelector('[data-search-input]');
    const searchButton = this.querySelector('[data-search-button]');
    
    // Only proceed if there are tabs
    if (tabs.length === 0) return;

    let currentTab = tabs[0].dataset.tab;
    let searchTerm = '';
    
    // View more functionality
    const setupViewMore = () => {
      tabContents.forEach(content => {
        const productsGrid = content.querySelector('[data-products-grid]');
        const viewMoreContainer = content.querySelector('[data-view-more-container]');
        const viewMoreButton = content.querySelector('[data-view-more-button]');
        const products = productsGrid.querySelectorAll('[data-product-item]');
        
        if (products.length > 0) {
          const isMobile = window.innerWidth <= 768;
          const maxItems = isMobile ? 4 : 8;
          
          if (products.length > maxItems) {
            viewMoreContainer.style.display = 'block';
            
            // Remove existing event listener to prevent duplicates
            const newButton = viewMoreButton.cloneNode(true);
            viewMoreButton.parentNode.replaceChild(newButton, viewMoreButton);
            
            // Add event listener with both click and touch events for mobile
            const handleViewMore = (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const isCollapsed = productsGrid.classList.contains('collapsed');
              const isMobile = window.innerWidth <= 768;
              const maxItems = isMobile ? 4 : 8;
              
              if (isCollapsed) {
                // Expand - show all items
                productsGrid.classList.remove('collapsed');
                products.forEach((product, index) => {
                  product.style.display = 'block';
                });
                newButton.textContent = 'View Less';
                newButton.classList.add('expanded');
              } else {
                // Collapse - hide items beyond maxItems
                productsGrid.classList.add('collapsed');
                products.forEach((product, index) => {
                  if (index >= maxItems) {
                    product.style.display = 'none';
                  } else {
                    product.style.display = 'block';
                  }
                });
                newButton.textContent = 'View More';
                newButton.classList.remove('expanded');
              }
            };
            
            // Add both click and touchstart events for better mobile support
            newButton.addEventListener('click', handleViewMore);
            newButton.addEventListener('touchstart', handleViewMore, { passive: false });
            
            // Also add mousedown for additional mobile support
            newButton.addEventListener('mousedown', handleViewMore);
          }
        }
      });
    };
    
    // Force reapply collapsed state for mobile
    const forceReapplyCollapsed = () => {
      tabContents.forEach(content => {
        const productsGrid = content.querySelector('[data-products-grid]');
        const products = productsGrid.querySelectorAll('[data-product-item]');
        const isMobile = window.innerWidth <= 768;
        const maxItems = isMobile ? 4 : 8;
        
        if (products.length > maxItems) {
          // Force hide items beyond maxItems using inline styles
          products.forEach((product, index) => {
            if (index >= maxItems) {
              product.style.display = 'none';
            } else {
              product.style.display = 'block';
            }
          });
        }
      });
    };
    
    // Tab switching functionality
    const switchTab = (tabName, skipSearch = false) => {
      currentTab = tabName;
      
      // Update active tab
      tabs.forEach(tab => {
        tab.classList.toggle('active', tab.dataset.tab === tabName);
      });
      
      // Scroll to active tab if needed
      const activeTab = Array.from(tabs).find(tab => tab.dataset.tab === tabName);
      if (activeTab) {
        const tabsWrapper = this.querySelector('.tabs-wrapper');
        const tabRect = activeTab.getBoundingClientRect();
        const wrapperRect = tabsWrapper.getBoundingClientRect();
        
        // Check if tab is outside the visible area
        if (tabRect.left < wrapperRect.left || tabRect.right > wrapperRect.right) {
          // Calculate scroll position to center the active tab
          const scrollLeft = activeTab.offsetLeft - (tabsWrapper.offsetWidth / 2) + (activeTab.offsetWidth / 2);
          tabsWrapper.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      }
      
      // Update active content
      tabContents.forEach(content => {
        content.classList.toggle('active', content.dataset.tabContent === tabName);
      });
      
      // Apply search filter to new tab (only if not skipping)
      if (searchTerm && !skipSearch) {
        filterProducts(searchTerm, true);
      }
    };
    
    // Search functionality
    const filterProducts = (term, skipTabSwitch = false) => {
      searchTerm = term.toLowerCase();
      
      // If no search term, show all products in current tab
      if (!searchTerm) {
        tabContents.forEach(content => {
          const productsGrid = content.querySelector('[data-products-grid]');
          const noResults = content.querySelector('[data-no-results]');
          const viewMoreContainer = content.querySelector('[data-view-more-container]');
          const products = productsGrid.querySelectorAll('[data-product-item]');
          
          products.forEach(product => {
            product.style.display = 'block';
          });
          
          if (noResults) {
            noResults.style.display = 'none';
          }
          
          // Re-apply collapsed state and show view more if needed
          const isMobile = window.innerWidth <= 768;
          const maxItems = isMobile ? 4 : 8;
          if (products.length > maxItems) {
            productsGrid.classList.add('collapsed');
            viewMoreContainer.style.display = 'block';
          } else {
            productsGrid.classList.remove('collapsed');
            viewMoreContainer.style.display = 'none';
          }
        });
        
        // Force reapply collapsed state for mobile
        forceReapplyCollapsed();
        
        // Re-setup view more functionality after search is cleared
        // Use setTimeout to ensure DOM updates are complete
        setTimeout(() => {
          setupViewMore();
        }, 100);
        return;
      }
      
      // Search across all tabs
      let foundResults = false;
      
      tabContents.forEach(content => {
        const productsGrid = content.querySelector('[data-products-grid]');
        const noResults = content.querySelector('[data-no-results]');
        const viewMoreContainer = content.querySelector('[data-view-more-container]');
        const products = productsGrid.querySelectorAll('[data-product-item]');
        
        let visibleCount = 0;
        
        // Remove collapsed class during search to show all results
        productsGrid.classList.remove('collapsed');
        
        products.forEach(product => {
          const title = product.dataset.productTitle;
          const isVisible = title.includes(searchTerm);
          
          product.style.display = isVisible ? 'block' : 'none';
          if (isVisible) visibleCount++;
        });
        
        // Show/hide no results message
        if (noResults) {
          noResults.style.display = visibleCount === 0 ? 'block' : 'none';
        }
        
        // Hide view more during search
        viewMoreContainer.style.display = 'none';
        
        // If this tab has results, mark that we found something
        if (visibleCount > 0) {
          foundResults = true;
        }
      });
      
      // If we have search results, switch to the first tab that has results (only if not skipping)
      if (foundResults && searchTerm && !skipTabSwitch) {
        for (let i = 0; i < tabContents.length; i++) {
          const content = tabContents[i];
          const productsGrid = content.querySelector('[data-products-grid]');
          const products = productsGrid.querySelectorAll('[data-product-item]');
          
          let hasVisibleProducts = false;
          products.forEach(product => {
            if (product.style.display !== 'none') {
              hasVisibleProducts = true;
            }
          });
          
          if (hasVisibleProducts) {
            const tabName = content.dataset.tabContent;
            switchTab(tabName, true);
            break;
          }
        }
      }
    };
    
    // Event listeners
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        switchTab(tab.dataset.tab);
      });
    });
    
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        filterProducts(e.target.value);
      });
      
      searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          filterProducts(e.target.value);
        }
      });
    }
    
    if (searchButton) {
      searchButton.addEventListener('click', () => {
        filterProducts(searchInput.value);
      });
    }
    
    // Handle window resize
    window.addEventListener('resize', () => {
      setupViewMore();
    });
    
    // Initialize with first available tab
    if (tabs.length > 0) {
      switchTab(tabs[0].dataset.tab);
      setupViewMore();
    }
  }
}

customElements.define('manuals-search', ManualsSearch);

/**
 * Troubleshooting Search Component
 */
if (!customElements.get('troubleshooting-search')) {
  class TroubleshootingSearch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const tabs = this.querySelectorAll('[data-tab]');
      const tabContents = this.querySelectorAll('[data-tab-content]');
      const modalTriggers = this.querySelectorAll('[data-modal-trigger]');
      const modalOverlay = this.querySelector('[data-modal-overlay]');
      const modalClose = this.querySelector('[data-modal-close]');
      const modalBody = this.querySelector('.modal-body');

      // Only proceed if there are tabs
      if (tabs.length === 0) return;

      let currentTab = tabs[0].dataset.tab;

      // Tab switching functionality
      const switchTab = (tabName) => {
        currentTab = tabName;
        
        // Update active tab
        tabs.forEach(tab => {
          tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        
        // Scroll to active tab if needed
        const activeTab = Array.from(tabs).find(tab => tab.dataset.tab === tabName);
        if (activeTab) {
          const tabsWrapper = this.querySelector('.tabs-wrapper');
          const tabRect = activeTab.getBoundingClientRect();
          const wrapperRect = tabsWrapper.getBoundingClientRect();
          
          // Check if tab is outside the visible area
          if (tabRect.left < wrapperRect.left || tabRect.right > wrapperRect.right) {
            // Calculate scroll position to center the active tab
            const scrollLeft = activeTab.offsetLeft - (tabsWrapper.offsetWidth / 2) + (activeTab.offsetWidth / 2);
            tabsWrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }
        
        // Update active content
        tabContents.forEach(content => {
          content.classList.toggle('active', content.dataset.tabContent === tabName);
        });
      };

      // Modal functionality
      const openModal = (modalId) => {
        // Find the corresponding modal content
        const modalContentData = this.querySelector(`[data-modal-content="${modalId}"]`);
        if (!modalContentData) return;

        // Clone the modal content and insert it into the modal body
        const contentClone = modalContentData.cloneNode(true);
        contentClone.style.display = 'block';
        
        modalBody.innerHTML = '';
        modalBody.appendChild(contentClone);
        
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        modalOverlay.classList.remove('active');
        document.body.style.overflow = '';
      };

      // Event listeners
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          switchTab(tab.dataset.tab);
        });
      });

      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const modalId = trigger.dataset.modalTrigger;
          openModal(modalId);
        });
      });

      if (modalClose) {
        modalClose.addEventListener('click', closeModal);
      }

      if (modalOverlay) {
        modalOverlay.addEventListener('click', (e) => {
          if (e.target === modalOverlay) {
            closeModal();
          }
        });
      }

      // Close modal on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
          closeModal();
        }
      });

      // Initialize with first available tab
      if (tabs.length > 0) {
        switchTab(tabs[0].dataset.tab);
      }
    }
  }

  customElements.define('troubleshooting-search', TroubleshootingSearch);
}

/**
 * User Video Search Module - 纯JavaScript轮播实现
 */
class UserVideoSearch extends HTMLElement {
  constructor() {
    super();
    this.swipers = new Map(); // 存储每个tab的swiper实例
    this.init();
  }

  init() {
    this.setupTabs();
    this.setupSearch();
    this.setupVideoPlay();
    this.initAllSwipers();
    this.setupResponsive();
  }

  initAllSwipers() {
    // 初始化所有tab下的swiper
    const carousels = this.querySelectorAll('.videos-carousel');
    carousels.forEach(carousel => {
      this.initSwiperForCarousel(carousel);
    });
  }

  initSwiperForCarousel(carousel) {
    const swiperEl = carousel.querySelector('.swiper');
    if (!swiperEl) return;

    // 销毁旧实例
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    // 获取当前轮播的slides数量
    const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const isMobile = window.innerWidth <= 1023;
    
    // 计算初始索引：PC端且slides数量>=3时，从第1个开始
    const initialSlide = (!isMobile && slidesCount >= 3) ? 1 : 0;

    // 响应式断点配置
    const config = {
      initialSlide: initialSlide,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
          loop: false
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: true,
          loop: false
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 32,
          centeredSlides: true,
          loop: false
        },
        1440: {
          slidesPerView: 2.5,
          spaceBetween: 40,
          centeredSlides: true,
          loop: false
        }
      },
      effect: 'slide',
      speed: 600,
      allowTouchMove: true,
      touchRatio: 1,
      grabCursor: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true
      },
      on: {
        init: function() {
          // console.log('UserVideo Swiper initialized');
        },
        slideChange: function() {
          // console.log('Slide changed to', this.activeIndex);
        }
      }
    };

    // 初始化Swiper
    const swiper = new window.Swiper(swiperEl, config);
    this.swipers.set(carousel, swiper);
  }

  // 在tab切换、窗口resize时重新初始化
  reconfigureCarousels() {
    this.swipers.forEach((swiper, carousel) => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    this.swipers.clear();
    this.initAllSwipers();
  }

  setupTabs() {
    const tabItems = this.querySelectorAll('.tab-item');
    const contentContainers = this.querySelectorAll('.content-container');
    const tabsWrapper = this.querySelector('.tabs-wrapper');
    tabItems.forEach(tab => {
      tab.addEventListener('click', () => {
        tabItems.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const tabName = tab.dataset.tab;
        contentContainers.forEach(container => {
          if (container.dataset.tabContent === tabName) {
            container.classList.add('active');
          } else {
            container.classList.remove('active');
          }
        });
        
        // 添加tab滑动功能
        setTimeout(() => {
          tab.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }, 50);
        
        setTimeout(() => {
          const activeContainer = this.querySelector('.content-container.active');
          if (activeContainer) {
            const carousel = activeContainer.querySelector('.videos-carousel');
            if (carousel) {
              this.initSwiperForCarousel(carousel);
            }
          }
        }, 100);
        this.currentTab = tabName;
      });
    });
  }

  setupSearch() {
    const searchInput = this.querySelector('[data-search-input]');
    const searchButton = this.querySelector('[data-search-button]');

    const performSearch = () => {
      const searchTerm = searchInput.value.toLowerCase().trim();
      this.searchVideos(searchTerm);
    };

    searchInput.addEventListener('input', performSearch);
    searchButton.addEventListener('click', performSearch);
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        performSearch();
      }
    });
  }

  searchVideos(searchTerm) {
    const allTabs = ['label1', 'label2', 'label3', 'label4', 'label5', 'label6', 'label7', 'label8'];
    let foundResults = false;
    let firstResultTab = null;
    let firstResultIndex = 0;

    // 如果搜索词为空，重置所有显示状态
    if (searchTerm === '') {
      this.resetAllTabs();
      return;
    }

    // 搜索所有tab
    allTabs.forEach(tab => {
      const container = this.querySelector(`[data-tab-content="${tab}"]`);
      if (!container) return;

      const videoItems = container.querySelectorAll('[data-video-item]');
      const noResults = container.querySelector('[data-no-results]');
      let hasResults = false;

      videoItems.forEach((item, index) => {
        const title = item.dataset.videoTitle;
        if (title && title.toLowerCase().includes(searchTerm)) {
          hasResults = true;
          
          if (!foundResults) {
            foundResults = true;
            firstResultTab = tab;
            firstResultIndex = index;
          }
        }
      });

      // 根据搜索结果显示/隐藏items
      videoItems.forEach(item => {
        const title = item.dataset.videoTitle;
        if (title && title.toLowerCase().includes(searchTerm)) {
          item.style.display = 'flex';
        } else {
          item.style.display = 'none';
        }
      });

      if (noResults) {
        noResults.style.display = hasResults ? 'none' : 'block';
      }
    });

    // 如果找到搜索结果，跳转到第一个结果
    if (foundResults && firstResultTab) {
      this.switchTab(firstResultTab);
      setTimeout(() => {
        this.scrollToSearchResult(firstResultTab, firstResultIndex);
      }, 300);
    }
  }

  // 重置所有tab显示状态
  resetAllTabs() {
    const allTabs = ['label1', 'label2', 'label3', 'label4', 'label5', 'label6', 'label7', 'label8'];
    allTabs.forEach(tab => {
      const container = this.querySelector(`[data-tab-content="${tab}"]`);
      if (!container) return;

      const videoItems = container.querySelectorAll('[data-video-item]');
      const noResults = container.querySelector('[data-no-results]');
      
      videoItems.forEach(item => {
        item.style.display = 'flex';
      });
      
      if (noResults) {
        noResults.style.display = 'none';
      }
    });
  }

  // 添加缺失的switchTab方法
  switchTab(tabName) {
    const tabItems = this.querySelectorAll('.tab-item');
    const contentContainers = this.querySelectorAll('.content-container');
    
    // 切换active类
    tabItems.forEach(t => t.classList.remove('active'));
    const targetTab = this.querySelector(`[data-tab="${tabName}"]`);
    if (targetTab) {
      targetTab.classList.add('active');
      // 横向滚动到可见区域
      targetTab.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
    }
    
    // 切换内容
    contentContainers.forEach(container => {
      if (container.dataset.tabContent === tabName) {
        container.classList.add('active');
      } else {
        container.classList.remove('active');
      }
    });
    
    // 重新初始化当前tab下的轮播
    setTimeout(() => {
      const activeContainer = this.querySelector('.content-container.active');
      if (activeContainer) {
        const carousel = activeContainer.querySelector('.videos-carousel');
        if (carousel) {
          this.initSwiperForCarousel(carousel);
        }
      }
    }, 100);
    
    // 记录当前tab
    this.currentTab = tabName;
  }

  scrollToSearchResult(tabName, resultIndex) {
    const activeContainer = this.querySelector('.content-container.active');
    if (!activeContainer) return;

    const carousel = activeContainer.querySelector('.videos-carousel');
    if (!carousel) return;

    const carouselInstance = this.swipers.get(carousel);
    if (carouselInstance) {
      // 使用slideTo方法，让搜索结果居中显示
      carouselInstance.slideTo(resultIndex, 600);
    }
  }

  setupVideoPlay() {
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-video-play]')) {
        const playButton = e.target.closest('[data-video-play]');
        const videoItem = playButton.closest('[data-video-item]');
        const videoPlayer = videoItem.querySelector('.video-player');
        const coverImage = videoItem.querySelector('.video-cover-image');
        const videoTitle = videoItem.querySelector('.video-title');

        if (videoPlayer) {
          // Hide cover, play button and title when video starts playing
          if (coverImage) coverImage.style.display = 'none';
          playButton.style.display = 'none';
          if (videoTitle) videoTitle.classList.add('hidden');

          videoPlayer.classList.add('is-playing');

          // Handle different video types
          const iframe = videoPlayer.querySelector('iframe');
          const video = videoPlayer.querySelector('video');

          if (iframe) {
            // YouTube video - 简化处理
            const currentSrc = iframe.src;
            if (!currentSrc.includes('autoplay=1')) {
              const separator = currentSrc.includes('?') ? '&' : '?';
              iframe.src = currentSrc + separator + 'autoplay=1&mute=0';
            }
          } else if (video) {
            // Hosted video
            video.muted = true;
            video.play().catch(() => {
              // Autoplay failed, show play button and title
              playButton.style.display = 'flex';
              if (videoTitle) videoTitle.classList.remove('hidden');
            });
          }
        }
      }
    });
  }

  setupResponsive() {
    let resizeTimeout;
    let lastWindowWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentWindowWidth = window.innerWidth;
        if (Math.abs(currentWindowWidth - lastWindowWidth) > 50) {
          lastWindowWidth = currentWindowWidth;
          this.reconfigureCarousels();
        }
      }, 200);
    });
  }
}

customElements.define('uservideo-search', UserVideoSearch);